const pattern = /:\w+:/i;

export default pattern;